import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Navigate, Route, Routes } from "react-router-dom";
import { TooltipProvider } from "@/components/ui/tooltip";
import Index from "./pages/Index.tsx";
import ScrollToTop from "./components/ScrollToTop";
import UrlNormalizer from "./components/site/UrlNormalizer";
import CookieBanner from "./components/site/CookieBanner";

// Eager (no Suspense): a lazy boundary rendered `null` on the server and a
// real subtree on the client, which broke hydration on every route.
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";


// Phase-1 SSG routes must be eager so renderToString resolves them
// synchronously — a Suspense boundary would emit empty HTML instead.
import Kundenstimmen from "./pages/Kundenstimmen.tsx";
import Empfehlung from "./pages/Empfehlung.tsx";
import AltersvorsorgeAnalyse from "./pages/AltersvorsorgeAnalyse.tsx";
import Blog from "./pages/Blog.tsx";
import BlogPost from "./pages/BlogPost.tsx";
import Glossar from "./pages/Glossar.tsx";
import GlossarEntry from "./pages/GlossarEntry.tsx";
import Karriere from "./pages/Karriere.tsx";
import Team from "./pages/Team.tsx";
import TeamJannKromminga from "./pages/TeamJannKromminga.tsx";
import Leistungen from "./pages/Leistungen.tsx";
import LeistungDetail from "./pages/LeistungDetail.tsx";
import Impressum from "./pages/Impressum.tsx";
import Datenschutz from "./pages/Datenschutz.tsx";
import Erstinformation from "./pages/Erstinformation.tsx";
import Barrierefreiheit from "./pages/Barrierefreiheit.tsx";
import NotFound from "./pages/NotFound.tsx";
import Standorte from "./pages/Standorte.tsx";
import CityRoute from "./pages/CityRoute.tsx";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />

      <>
        <ScrollToTop />
        <UrlNormalizer />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/kundenstimmen" element={<Kundenstimmen />} />
          <Route path="/bewertungen" element={<Navigate to="/kundenstimmen" replace />} />
          <Route path="/empfehlung" element={<Empfehlung />} />
          <Route path="/deine-foerderanalyse" element={<AltersvorsorgeAnalyse />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/glossar" element={<Glossar />} />
          <Route path="/glossar/:slug" element={<GlossarEntry />} />
          <Route path="/karriere" element={<Karriere />} />
          <Route path="/team" element={<Team />} />
          <Route path="/team/jann-kromminga" element={<TeamJannKromminga />} />
          <Route path="/leistungen" element={<Leistungen />} />
          <Route path="/leistungen/:slug" element={<LeistungDetail />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/erstinformation" element={<Erstinformation />} />
          <Route path="/barrierefreiheit" element={<Barrierefreiheit />} />
          <Route path="/standorte" element={<Standorte />} />
          {/* Alle Stadtseiten (/finanzberatung-<stadt>) laufen über eine Route */}
          <Route path="/:cityPath" element={<CityRoute />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
        <CookieBanner />
      </>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
